import { PayorTypeIds } from 'app/pages/admin/Payors/Edit/constants';
import { getSegmentsFromUser } from 'app/services/beamer';
import { getEnumKeyAsString } from 'app/utils/lib/enum';
import { isTriumphInternal } from 'app/utils/lib/user';

import { PendoConfig } from './types';
import { BeamerUserDto } from '../beamer/types';

// we use the BeamerUserDto interface to initialize Pendo, because it already most of the necessary information
export const setPendoConfig = (
  beamerUser: BeamerUserDto | null,
) => {
  const segments = beamerUser ? getSegmentsFromUser(beamerUser) : [];

  const claimedRelationships = beamerUser?.claimedRelationships ?? [];
  const unclaimedRelationships = beamerUser?.unclaimedRelationships ?? [];
  const user = beamerUser?.user;
  const company = user?.company;

  const isInternal = isTriumphInternal(user?.roles?.map(role => role.id) ?? []);
  const payorType = getEnumKeyAsString(PayorTypeIds, user?.payorDetails?.payorTypeId ?? -1);

  /* eslint-disable @typescript-eslint/naming-convention */
  const pendoConfig: PendoConfig = {
    account: {
      beamer_csv: segments,
      company_name: company?.name ?? '',
      company_type: company?.type?.name ?? '',
      connected_relationships: claimedRelationships?.length ?? 0,
      dot_no: company?.dotNumber ?? '',
      id: company?.id ?? '',
      mc_no: company?.mcNumber ?? '',
      payor_type: payorType,
      pending_relationships: unclaimedRelationships?.length ?? 0,
    },
    visitor: {
      email: user?.email ?? '',
      full_name: user?.name ?? '',
      id: user?.id ?? '',
      is_employee: isInternal,
      roles: (user?.roles?.map(role => role.name) ?? []).filter(Boolean) as string[],
    },
  };
  /* eslint-enable @typescript-eslint/naming-convention */

  // This function creates visitors and accounts in Pendo
  // You will need to replace <visitor-id-goes-here> and <account-id-goes-here> with values you use in your app
  // Please use Strings, Numbers, or Bools for value types.
  window.pendo?.initialize?.(pendoConfig);

  window.pendo?.updateOptions?.(pendoConfig);
};
